module.exports = __webpack_public_path__ + "img/stack-background.4233cd66.png";